import { Injectable, EventEmitter } from '@angular/core';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { BuilderModel } from '../../fb/models/builder.model';
import { ApiService } from '@dotgov/z_core';

@Injectable({
  providedIn: 'root',
})
export class BuilderService {
  anyActiveDragging = false;
  draggedModel: any;
  // Filter and throttle calls from _setFocus
  onFocus = new EventEmitter<any>();
  table: string;

  // Everyone call this
  private _setModel = new EventEmitter<Event>();
  private _availableModels: BuilderModel;

  constructor(private api: ApiService) {
    this._setModel
      .pipe(
        throttleTime(100),
        distinctUntilChanged(),
      )
      .subscribe(model => {
        this.onFocus.emit(model);
      });
  }

  set availableModels(models) {
    this._availableModels = models;
  }

  get availableModels() {
    return this._availableModels;
  }

  onEventTriggered(eventName: string, model) {
    this.anyActiveDragging = eventName === 'drag';
    this.draggedModel = model;
  }

  setFocus(model: any) {
    this._setModel.emit(model);
  }

  async extractTemplate(type, name) {
    if (!this.table) {
      return Promise.reject('No table available');
    }
    const template = await this.api.get('Designer', ['templates', this.table, type, name]);
    return { name, template: template.data };
  }
}
